import { OrderStepType, TIconProps } from 'Pages/orders_design'
import { FormNavigationTypes, UITypes } from 'LibNeo'
import { FieldNames } from 'Constants/FieldNames'

export enum BlockKeys {
	ORDER_DATA,
	REASSIGN,
	RESERVE,
	WITHOUT_BANK,
}

export type InitialItemType = {
	title: string
	description: string
	steps?: OrderStepType[]
	type: FormNavigationTypes
	isActive?: boolean
}

export const translateBlockTitle = {
	[BlockKeys.ORDER_DATA]: 'Общая информация',
	[BlockKeys.REASSIGN]: 'Перезакрепление',
	[BlockKeys.RESERVE]: 'Резервирование счёта',
	[BlockKeys.WITHOUT_BANK]: 'Без визита в банк',
}

export const translateBlockDescription = {
	[BlockKeys.ORDER_DATA]: 'Предоставление общих сведений по заявке',
	[BlockKeys.REASSIGN]:
		'Загрузите скан/фото подписанного документа на передачу согласия вашего клиента на обработку персональных данных',
	[BlockKeys.RESERVE]: 'Предоставление сведений для дистанционного резервирования счёта',
	[BlockKeys.WITHOUT_BANK]: 'Параметры подключения продукта «Торговый эквайринг»',
}
export const initialList = Object.keys(translateBlockTitle)

export const fieldsByFormBlock = {
	[BlockKeys.ORDER_DATA]: [
		FieldNames.FIRST_NAME,
		FieldNames.LAST_NAME,
		FieldNames.MIDDLE_NAME,
		FieldNames.COMPANY_NAME,
		FieldNames.EMAIL,
		FieldNames.PHONE,
		FieldNames.REGION_ID,
		FieldNames.CITY_ID,
		FieldNames.MERCHANT_BRANCH_ID,
		FieldNames.NOTICE_NUMBER,
		FieldNames.CALL_ME,
		FieldNames.ADD_INFO,
		FieldNames.DEAL_AMOUNT,
		FieldNames.DEAL_SUBJECT_ID,
		FieldNames.ATTACHMENTS,
	],
	[BlockKeys.RESERVE]: [
		FieldNames.CITY_ID,
		FieldNames.MERCHANT_BRANCH_ID,
		FieldNames.NOTICE_NUMBER,
		FieldNames.CALL_ME,
		FieldNames.ADD_INFO,
		FieldNames.DEAL_AMOUNT,
		FieldNames.DEAL_SUBJECT_ID,
		FieldNames.ATTACHMENTS,
	],
	[BlockKeys.WITHOUT_BANK]: [
		FieldNames.EQUIP_TYPE,
		FieldNames.EQUIP_CONNECT_TYPE,
		FieldNames.EQUIP_AMOUNT,
		FieldNames.INSTALL_REGION_ID,
		FieldNames.MCC_CODE_ID,
		FieldNames.MCC_GROUP_ID,
		FieldNames.ORGADDRESS,
		FieldNames.IS_CLIENT,
		FieldNames.ACCOUNT_NUMBER,
		FieldNames.ACCOUNT_BANK_BIC,
		FieldNames.POSADDRESS,
		FieldNames.POS_NAME,
		FieldNames.QUESTIONS_CONTACT_PHONE,
		FieldNames.INSTALL_DATE,
		FieldNames.DECISION_MAKER_PERSON_NAME,
		FieldNames.DECISION_MAKER_PERSON_LAST_NAME,
		FieldNames.DECISION_MAKER_PERSON_FIRST_NAME,
		FieldNames.DECISION_MAKER_PERSON_MIDDLE_NAME,
		FieldNames.DECISION_MAKER_PHONE,
		FieldNames.DECISION_MAKER_EMAIL,
		FieldNames.FINANCE_PERSON_NAME,
		FieldNames.FINANCE_PERSON_EMAIL,
		FieldNames.MANAGER_NAME,
		FieldNames.MANAGER_LAST_NAME,
		FieldNames.MANAGER_FIRST_NAME,
		FieldNames.MANAGER_MIDDLE_NAME,
		FieldNames.MANAGER_PHONE,
		FieldNames.MANAGER_EMAIL,
	],
}

export const consentIcons: Record<string, TIconProps> = {
	inProgress: { name: 'clock', type: UITypes.WARNING },
	error: { name: 'error-filled', type: UITypes.DANGER },
	success: { name: 'check-circle', type: UITypes.PRIMARY },
}
